import type { AddToast } from './types';

export const showToast: AddToast = (toast) => window.addToast?.(toast);

const success = (title: React.ReactNode, message?: string): void => showToast({ title, message });

const info = (title: string, message?: string, duration?: number): void =>
  showToast({ type: 'info', title, message, duration });

const warning = (title: string, message?: string): void =>
  showToast({ type: 'warning', title, message, duration: 0 });

const error = (title: string, message?: string): void =>
  showToast({ type: 'danger', title, message, duration: 0 });

export const toast = {
  success,
  info,
  warning,
  error,
};
